import React, { useState, useEffect } from "react";
import {
  Typography,
  Input,
  Button,
  Dropdown,
  Menu,
  Icon,
  message,
  Tabs,
} from "antd";
import { platformApi } from "../../../api";
import CustomerTable from "./CustomerTable";

const { Title } = Typography;
const { Search } = Input;
const { Item } = Menu;
const { TabPane } = Tabs;

function SalesFeedbackCall() {
  const [limit, setLimit] = useState(10);
  const [dataSource, setData] = useState([]);
  const [spinning, setSpinning] = useState(false);
  const [search, setSearch] = useState({ searchString: null });
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [tab, setTab] = useState("NPF");
  const [activeKey, setActivekey] = useState("1");

  const getMenu = () => {
    let size = count / 10 + (count % 10 ? 1 : 0);
    let menus = [];
    menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item
        onClick={() => {
          setLimit(menu);
          setPage(1);
        }}
        key={menu}
      >
        {menu}
      </Item>
    ));
  };

  const menu = <Menu>{getMenu()}</Menu>;

  useEffect(() => {
    loadData();
  }, [page, limit, search, tab]);

  const loadData = () => {
    setSpinning(true);
    let payload = {
      page: page,
      size: limit,
      searchString: search.searchString,
      status: tab,
    };

    platformApi
      .post("/api/saleRegister/getPage", payload)
      .then((result) => {
        setSpinning(false);
        if (result.data.code === 200) {
          const { data } = result.data;
          setData(data.saleRegisters || []);
          setCount(data.count || 0);
        } else {
          message.error("Unable to fetch Sale Registers", 2);
        }
      })
      .catch((error) => {
        setSpinning(false);
        console.error("Error on Sale Register : ", error);
        message.error("Unable to fetch Sale Registers", 2);
      });
  };

  const handleTabChange = (activeKey) => {
    let newTab = "";
    switch (activeKey) {
      case "1":
        newTab = "NPF";
        break;
      case "2":
        newTab = "COMPLETED";
        break;
      default:
        newTab = "NPF";
    }

    if (tab !== newTab) {
      setTab(newTab);
    }

    setSearch({ searchString: null });
    setPage(1);
    setActivekey(activeKey);
  };

  return (
    <div>
      <div className="accessories-head">
        <Title style={{ width: "60%" }} level={4}>
          Sales Feedback Call [{count}]
          <span style={{ margin: ".5rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit} &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          style={{ width: "30%" }}
          placeholder="Search Phone / Chassis"
          onSearch={(event) => {
            let searches = { searchString: event };
            setPage(1);
            setSearch(searches);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearch({ searchString: null });
              setPage(1);
            }
          }}
        />
      </div>
      <Tabs activeKey={String(activeKey)} onChange={handleTabChange}>
        <TabPane tab={<span>Pending</span>} key="1">
          <CustomerTable
            spinner={spinning}
            dataSource={dataSource || []}
            status={tab}
            pagination={{
              onChange: (page) => {
                setPage(page);
              },
              pageSize: limit,
              total: count,
              current: page,
              showQuickJumper: true,
            }}
          />
        </TabPane>
        <TabPane tab={<span>Completed</span>} key="2">
          <CustomerTable
            spinner={spinning}
            dataSource={dataSource || []}
            status={tab}
            pagination={{
              onChange: (page) => {
                setPage(page);
              },
              pageSize: limit,
              total: count,
              current: page,
              showQuickJumper: true,
            }}
          />
        </TabPane>
      </Tabs>
    </div>
  );
}

export default SalesFeedbackCall;
